import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../components/CustomNavbar";
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from "../../components/CustomTable";
import {
  getLabs,
  saveLabs,
  editLabs,
  deleteLabs,
} from "../../redux/laboratories/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import moment from "moment";
import CustomPagint from "../../components/CustomPagint";

const Laboratories = (props) => {
  const schema = Yup.object().shape({
    nombre: Yup.string().ensure().required("**Campo requerido"),
    // .test(
    //   "codigo-format",
    //   "**Solo admite letras",
    //   (value) => {
    //     // Lógica de temporizador para la validación
    //     if (value === "" || !value) {
    //       return true; // Campo vacío, no validamos todavía
    //     }

    //     if (value.length < 1) {
    //       return true; // No validamos hasta que se escriban al menos 1 caracter
    //     }

    //     // Aquí puedes definir tu patrón personalizado
    //     const pattern = /[A-Za-zñÑáéíóúÁÉÍÓÚ0-9_-\s]+/;
    //     return pattern.test(value);
    //   }
    // ),
  });

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  //const [loadingType, setLoadingType] = useState('initial');
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const { labs, labsLength, loading, saveLoading, labsError, formError } =
    useSelector((store) => store.labs);
  const pages = Math.ceil(labsLength / limit);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      id: "fecha",
      Header: "Ultima actualización",
      Filter: "",
      Cell: (value) => moment(value.row.original.fecha).format("DD/MM/YYYY"),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getALabs = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getLabs({
        offset: offs,
        limit: lim,
        itype: parseInt(props.match.params.type),
        filter: filt,
      })
    );

  useEffect(() => {
    getALabs();
  }, [props.match.params.type, filter]);

  const addLab = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getALabs(oOffset, limit, e.target.filter.value);
  };

  const onSubmitLabs = (req) => {
    // e.preventDefault();
    // const form = e.currentTarget;
    // if (form.checkValidity() === false) {
    //   setValidated(true);
    //   return;
    // }

    // const req = {
    //   nombre: e.target.nombre.value,
    //   fecha: moment(new Date()).format("YYYY-MM-DD"),
    // };

    req.fecha = moment(new Date()).format("YYYY-MM-DD");
    if (!edit) {
      dispatch(saveLabs(req, parseInt(props.match.params.type), setShowModal));
      // e.target.reset();
      // setShowModal(false);
    } else {
      dispatch(
        editLabs(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
      // setShowModal(false);
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getALabs(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteLabs(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              {parseInt(props.match.params.type) === 1
                ? "Laboratorios formal"
                : "Laboratorios funcional"}
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addLab()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!labsError && !loading && (
            <Alert variant="danger" className="m-2">
              {labsError}
            </Alert>
          )}
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : labsLength > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={labs} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={labsLength}
                pages={pages}
                pagFunc={getALabs}
              />
            </>
          ) : (
            <>
              {labsError === "" && (
                <Alert variant="info" className="my-4">
                  Aún no hay laboratorios, comienza agregando algunos
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitLabs}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar laboratorio" : "Crear laboratorio"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-1 mb-2">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Nombre de laboratorio / casa
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      id="nombre"
                      name="nombre"
                      isInvalid={touched.nombre && errors.nombre}
                      isValid={touched.nombre && !errors.nombre}
                      onBlur={handleBlur("nombre")}
                      onChange={handleChange}
                      value={values.nombre}
                      className="rounded-pill"
                      type="text"
                      placeholder="Nombre de laboratorio / casa"
                      // pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9_-\s]+"
                      //pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1\x26]+$"
                    ></Form.Control>
                    {touched.nombre && errors.nombre && (
                      // <div>
                      <small className="mx-2 text-danger">
                        {errors.nombre}
                      </small>
                      // </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row} className="mb-3">
              <Form.Label 
                column 
                sm="12"
                md="4">Fecha</Form.Label>
              <Col 
                sm="12"
                md="8">
                <Form.Control
                  name="fecha"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={ edit ? editItem.fecha : null}
                  placeholder="Fecha"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Col>
            </Form.Group> */}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Laboratories;
